/* eslint-disable no-return-assign */
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { useEffect, useRef, useState } from 'react';
import Flickity from 'react-flickity-component';
import mediaURL from '../../../../util/mediaURL';
import Icon from '../../Atoms/Icon';

const propTypes = exact({
  items: PropTypes.array.isRequired,
  selectedItems: PropTypes.array.isRequired,
  togglePackageOption: PropTypes.func.isRequired,
});

function TourTypeSubFilterSlider({ items, selectedItems, togglePackageOption }) {
  const [slidesCount, setSlidesCount] = useState(false);
  const [selectedSlideIndex, setSelectedSlideIndex] = useState(0);
  const flickityRef = useRef();

  const checkToUpdateUI = () => {
    setSlidesCount(flickityRef.current?.slides.length);
    setSelectedSlideIndex(flickityRef.current.selectedIndex);
    flickityRef.current.resize();
  };

  const flickityRefFunc = (ref) => {
    flickityRef.current = ref;
    flickityRef.current.on('ready', checkToUpdateUI);
    flickityRef.current.on('change', checkToUpdateUI);

    flickityRef.current.on(
      'dragStart',
      () => (flickityRef.current.slider.style.pointerEvents = 'none')
    );
    flickityRef.current.on(
      'dragEnd',
      () => (flickityRef.current.slider.style.pointerEvents = 'auto')
    );
  };

  useEffect(() => {
    const handleWindowResize = debounce(checkToUpdateUI, 1000 / 6);
    window.addEventListener('resize', handleWindowResize, { passive: true });
    return () => window.removeEventListener('resize', handleWindowResize);
  }, [checkToUpdateUI]);

  return (
    <>
      <Flickity
        className="PackageFilter_slider"
        flickityRef={flickityRefFunc}
        options={{
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          groupCells: true,
          setGallerySize: false,
          prevNextButtons: false,
          freeScroll: true,
          draggable: '>1',
        }}
      >
        {items.map((item) => (
          <div key={item.id} className="PackageFilter_field PackageFilter_slider-item">
            <div className="PackageFilter_input">
              <button
                type="button"
                className={`PackageFilter_button Button ${
                  selectedItems.includes(item.id) ? 'active' : ''
                }`}
                onClick={() => togglePackageOption(item.id)}
              >
                {item.icon && (
                  <img
                    className="PackageFilter_itemIcon"
                    src={mediaURL(item.icon.url)}
                    alt={item.icon.alt}
                  />
                )}
                {item.title}
              </button>
            </div>
          </div>
        ))}
      </Flickity>
      {slidesCount > 1 && (
        <div className="PackageFilter_field PackageFilter_optionNavigation">
          <div className="PackageFilter_input">
            <div className="PackageFilter_button PackageFilter_navigation">
              <button
                className="PackageFilter_navigationButton"
                type="button"
                onClick={() => flickityRef.current?.previous()}
              >
                <Icon
                  id="arrow-left"
                  blockName={`PackageFilter_navigationArrow ${
                    selectedSlideIndex === 0 ? 'PackageFilter_navigationArrow-disabled' : ''
                  }`}
                />
              </button>
              {selectedSlideIndex + 1} of {slidesCount}{' '}
              <button
                className="PackageFilter_navigationButton"
                type="button"
                onClick={() => flickityRef.current?.next()}
              >
                <Icon
                  id="arrow-right"
                  blockName={`PackageFilter_navigationArrow ${
                    selectedSlideIndex + 1 === slidesCount
                      ? 'PackageFilter_navigationArrow-disabled'
                      : ''
                  }`}
                />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

TourTypeSubFilterSlider.propTypes = propTypes;

export default TourTypeSubFilterSlider;
